import React, { Component } from 'react';
import { searchData } from '../../../../schema/counsellor-counselling';
import Select2 from '../../../../components/FormComponent/select2';
import networkList from '../../../../constants/networkList';
import postService from '../../../../services/httpService';
import { Modal, Spin, Button, Input } from 'antd';
import Ins_upload from '../Insurance-Counselling/upload';
import Storage from './../../../../services/local-store';
import Finanical_clearance from '../Insurance-Counselling/finanical-clearance';
const { TextArea } = Input;
class Other_Counselling extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'loadding': false,
            visible: false,
            response: true,
            success: false,
            tokenNumber: null,
            current_token_count: null,
            tokenData: [
                {
                    id: 12,
                    name: 'name',
                    title: 'Name',
                    visible: true,
                    element: 'input',
                    required: true,
                    input_type: 'text',
                    placeholder: 'Enter',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-4'
                }, {
                    id: 14,
                    name: 'umr_number',
                    title: 'UMR',
                    visible: true,
                    element: 'input',
                    required: true,
                    input_type: 'text',
                    placeholder: 'Enter',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-4'
                }, {
                    id: 17,
                    name: 'ip',
                    title: 'IP',
                    visible: true,
                    element: 'input',
                    required: true,
                    input_type: 'text',
                    placeholder: 'Enter',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-4'
                }, {
                    id: 16,
                    name: 'phone_number',
                    title: 'Phone Number',
                    visible: true,
                    element: 'input',
                    required: true,
                    input_type: 'text',
                    placeholder: 'Enter',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-4'
                }, {
                    id: 15,
                    name: 'gender',
                    title: 'Gender',
                    visible: true,
                    element: 'input',
                    required: true,
                    input_type: 'text',
                    placeholder: 'Enter',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-4'
                }, {
                    id: 16,
                    name: 'age',
                    title: 'Age',
                    visible: true,
                    element: 'input',
                    required: true,
                    input_type: 'text',
                    placeholder: 'Enter',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-4'
                }, {
                    id: 16,
                    name: 'doctor_name',
                    title: 'Doctor',
                    visible: true,
                    element: 'input',
                    required: true,
                    input_type: 'text',
                    placeholder: 'Enter',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-4'
                }                
            ],
            showComments: false,
            comments: null,
            formData: [{
                id: 1,
                name: 'service_type',
                title: 'Service Type',
                visible: true,
                element: 'select2',
                required: true,
                input_type: 'select',
                placeholder: 'Financial Counselling',
                icon: 'user',
                rules: [
                    {
                        test: (value) => {
                            //return (value !== null && value.length > 0);
                            return true;
                        },
                        message: 'Please Select Service Type'
                    }
                ],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3'
            }]
        }
    }





    componentDidMount() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        const params = new URLSearchParams(this.props.location.search);
        const tags = params.get('rid');
        const ip = params.get('ip');
        this.setState((state) => ({ 'loadding': true }), () => {
            if ((tags !== undefined && tags !== null && tags !== '') || (ip !== undefined && ip !== null && ip !== '')) {
                this.renderBody(tags, ip);
            } else {
                this.cancelButton();
            }
        })

    }

    handleChange(attr) {

    }

    renderBody(tags, ip) {
        try {
            let { getConusellingDetails } = networkList;
            let payload = {
                "ip_no": ip ? ip : null,
                "counselling_id": tags ? parseInt(tags) : null
            }
            let { tokenData, formData, } = this.state;

            let showComments = true;

            postService(getConusellingDetails, 'POST', { 'data': payload }).then(res => {
                if (res.status) {
                    if (res['data'] && Array.isArray(res['data']) && res.data.length > 0)
                        console.log('test:', res.data)
                        Storage.store('counselling_view', res['data']);
                    let udata = res.data[0]
                    tokenData.map((d, i) => {
                        if (d.name === 'name') {
                            tokenData[i]['value'] = udata['patient_name'];
                        }
                        if (d.name === 'umr_number') {
                            tokenData[i]['value'] = udata['umr'];
                        }

                        if (d.name === 'gender') {
                            if (udata['patient_gender'] == 'male') {
                                tokenData[i]['value'] = 'Male';
                            } else {
                                tokenData[i]['value'] = 'Female';
                            }
                        }
                        if (d.name === 'age') {
                            tokenData[i]['value'] = udata['patient_age'];
                        }
                        if (d.name === 'ip') {
                            tokenData[i]['value'] = udata['ip_number'];
                        }

                        if (d.name === 'phone_number') {
                            tokenData[i]['value'] = udata['patient_mobile'];
                        }
                        if (d.name === 'doctor_name') {
                            tokenData[i]['value'] = udata['doctor_name'];
                        }

                    })

                    formData.map((form, key) => {
                        if (form.name === 'service_type') {
                            formData[key]['value'] = udata['service_id'];
                            formData[key]['text'] = udata['service_name_value'];
                            formData[key]['disable'] = true;
                        }
                    })
                    this.setState((state) => ({ 'showComments': showComments, 'loadding': false, 'formData': formData, tokenData: tokenData, 'tokenNumber': udata['token_number'], 'current_token_count': udata['current_token_count'], comments: udata['token_comment'] }))
                } else {
                    if (res['data'] && Array.isArray(res['data']) && res['data'].length === 0) {
                        Modal.info({
                            'title': 'Message',
                            'content': "Oops! something went wrong... Please try again."
                        })
                    }
                    this.setState((state) => ({ 'response': false, loadding: false }));
                }
            });
        } catch (error) {
            console.log(error);
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        }
    }

    // comments(event) {
    //     let value = event.target.value;
    //     this.setState((state) => ({ 'comments': value ? value : null }));
    // }

    cancelButton() {
        const params = new URLSearchParams(this.props.location.search);
        const nav_from = params.get('nav_from');
        const ip_id = params.get('ip');                
        const umr = params.get('umr');
        const unit = params.get('unit_id');
        if(nav_from && nav_from === 'patients-history'){
            // navigation to patients-history
            this.props.history.push(`/patients/patients-history-details?umr=${umr}&unit_id=${unit}`);
        }else if (nav_from && nav_from === 'on-bed-patients'){
            this.props
        .history
        .push(`/patients/on-bed-patient-details?patient_ip=${ip_id}&umr_no=${umr}&tab=2`)
        }
        else{
            this.props
            .history
            .push(`/counselling/counselling-list`);
        }
    }

    render() {
        let { tokenData, tokenNumber, formData, showComments, comments, response, current_token_count } = this.state
        return (
            <React.Fragment>
                 <div className="row mx-5 mt-3 mb-5">
                    <div className={showComments? `col-10 p-0` : `col-12`}>
                        <div className="card p-5">
                    {(response) && <React.Fragment>
                        <h1 className="text-center text-capitalize text-heading pb-5">token number {current_token_count ? current_token_count : '--'}</h1>
                        <div className="row w-100 mx-auto pb-4">

                            {tokenData.map((data, key) => {
                                return (<div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                                    <p className="data-label pr-1">{data.title ? data.title : ''}</p>
                                    <p className="data-item"> : {data.value ? data.value : '--'}</p>
                                </div>)
                            })}
                        </div>
                        <div className="row w-100 mx-auto">
                            {formData
                                .map((feild, key) => {

                                    if (feild.element === 'select2') {
                                        return (
                                            <div class="col-12 mt-3 mb-5">
                                                {(feild.name === 'patient_list' && feild.disable === false) &&
                                                    <div className="col-6">
                                                        <p className="mb-0 text-black pl-0" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="text-info" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Please Select Patient List</p>
                                                    </div>}
                                                <label className="data-label w-100">{feild.title}</label>
                                                <Select2
                                                    selectdata={feild}
                                                    changedObj={this.state.changedObj}
                                                    {...this.props}
                                                    {...this.state}
                                                    Queuedata={this.state.formData}
                                                    onselectChanges={this
                                                        .handleChange
                                                        .bind(this)} />
                                                {feild
                                                    .errors
                                                    .map((error, eKey) => {
                                                        return (
                                                            <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                        );
                                                    })}

                                            </div>
                                        )
                                    }
                                })}
                        </div>
                        {(showComments) &&
                            <div className="row w-100 mx-auto">
                                <div class="col-12 pb-5">
                                    <label className="data-label w-100">Comment</label>
                                    <TextArea rows={4} placeholder="" className="textarea" value={comments ? comments : ''} disabled />
                                </div>
                            </div>}
                        <div className="row justify-content-center">
                            <button className="btn btn-success btn-next text-capitalize" onClick={this.cancelButton.bind(this)}>cancel</button>
                        </div>
                    </React.Fragment>}
                </div>                
                </div>
                <div className={showComments ? `col-2 pl-1 pr-0 mb-5` : `d-none`}>
                        {(showComments) && 
                        <div className="card p-3 right-panel-sticky">
                            <h4 className="text-center pb-3">Other Info</h4>
                            <Ins_upload {...this.props} {...this.state} />
                            <Finanical_clearance {...this.props} {...this.state} />
                    </div>}
                    </div>
                </div>
                {(this.state.loadding) &&
                    <div className="loadding"> <Spin spinning={true}></Spin></div>}
            </React.Fragment>
        )

    }
}
export default Other_Counselling;